












































import { Component, Vue } from 'vue-property-decorator'
import {
  listPortalUsers,
  resetPasswordPortalUser,
  createPortalUser,
} from '../services/portal-users'

@Component
export default class PortalUsers extends Vue {
  email: string | null = null
  portalUsers: any = []
  loadingPortalUsers = false

  async createUser() {
    try {
      if (!this.email) {
        return this.$buefy.toast.open({
          message: 'E-mail não encontrado',
          type: 'is-danger',
        })
      }

      const email = this.email.trim()

      this.loadingPortalUsers = true
      await createPortalUser(email)
      this.email = null
      this.$buefy.toast.open({
        message: 'Usuário convidado com sucesso',
        type: 'is-success',
      })
      this.getPortalUsers()
    } catch (error) {
      this.$buefy.toast.open({
        message: 'Falha convidar usuário',
        type: 'is-danger',
      })
    } finally {
      this.loadingPortalUsers = false
    }
  }

  async getPortalUsers() {
    try {
      this.loadingPortalUsers = true
      this.portalUsers = await listPortalUsers()
    } catch (error) {
      this.$buefy.toast.open({
        message: 'Falha ao listar usuários',
        type: 'is-danger',
      })
    } finally {
      this.loadingPortalUsers = false
    }
  }

  async resetPassword(uid: string) {
    try {
      this.loadingPortalUsers = true
      await resetPasswordPortalUser(uid)
      this.$buefy.toast.open({
        message: 'E-mail para redefinir senha enviado com sucesso',
        type: 'is-success',
      })
    } catch (error) {
      this.$buefy.toast.open({
        message: 'Falha ao redefinir senha',
        type: 'is-danger',
      })
    } finally {
      this.loadingPortalUsers = false
    }
  }

  mounted() {
    this.getPortalUsers()
  }
}
